import api from './api';

const couponService = {
  // Customer
  apply: (code) => api.post('/coupons/apply', { code }),
  remove: () => api.delete('/coupons/remove'),

  // Merchant / Admin
  getMyCoupons: () => api.get('/coupons/my-coupons'),
  create: (data) => api.post('/coupons', data),
  update: (id, data) => api.put(`/coupons/${id}`, data),
  delete: (id) => api.delete(`/coupons/${id}`),
};

export default couponService;
